'use client';

import { usePathname, useRouter } from 'next/navigation';

import { FormSearchInput } from '@/components/momentum/components/forms/form-search-input';

export const HelpSearchInput = ({ placeholder }: { placeholder?: string }) => {
  const router = useRouter();
  const pathname = usePathname();

  const onSubmit = (data: { search: string }) => {
    const searchQuery = encodeURIComponent(data.search);
    const baseUrl =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'https://www.o2.co.uk';
    const currentPageUrl = `${baseUrl}${pathname}`;
    const referrerPageUrl = encodeURIComponent(currentPageUrl);
    router.push(
      `${baseUrl}/searchresult?query=${searchQuery}&referrerPageUrl=${referrerPageUrl}`
    );
  };

  return (
    <FormSearchInput
      placeholder={placeholder ?? 'Search help and support'}
      onSubmit={onSubmit}
    />
  );
};
